var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
const Foundation = isBrowser ? window.Foundation : {};
var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Helmet = require('react-helmet');
var Loader = require('react-loader');
var BodyOverlay = require('./layout/bodyOverlay.jsx');
var MainNav = require('./layout/mainNav.jsx');
var AppPromo = require('../../components/appPromo.jsx');
var Callout = require('../../components/callout.jsx');

var Education = createReactClass({
	mixins: [PureRenderMixin],

    componentDidMount: function() {
        this.props.setActiveBodyParts('');
        this.props.fetchEducationIfNeeded();

        if(this.props.location.query.newsletter && !this.$modal) {
            this.$modal = new Foundation.Reveal($('#newsletter-success'), {
                animationIn: "slide-in-down",
                animationOut: "slide-out-down",
                deepLink: true
            });
            this.$modal.open();
        }
    },

    componentWillUnmount: function(){
		this.props.clearThanksRegisteringMessage();
        this.$modal && this.$modal.close();
    },

    handleToggleBodyParts: function(bodyparts) {
        this.props.setActiveBodyParts(bodyparts)
    },

    handleToggleEducation: function(toggleType) {
        this.props.setActiveEducationToggle(toggleType);
    },

    handleModal: function(event) {
        event.preventDefault();
        this.$modal.close();
    },

    handleStateMessageCalloutClose: function(){
        this.props.clearThanksRegisteringMessage();
    },

    hasDataLoaded: function(){
        return !!(this.props.bodyparts && this.props.symptoms);
    },

    pageTitle: 'Gastrointestinal (GI) Tract | Anatomy Problems & Distress',

    getContent: function(){
        var bodyparts = this.props.bodyparts;
        var symptoms = this.props.symptoms;
        var activeBodyParts = this.props.activeBodyParts;
        var activeEducationToggle = this.props.activeEducationToggle;
        var qols = this.props.qols ? this.props.qols.filter(function(qol){
            return qol.id !== '1115f63cb840e30277000100'; // exclude myqol toolbox
        }) : [];

        var children = [
			<div className="content-header-wrapper" key={'content-header-wrapper'}>
				<div className="row column content-header">
					<h1>Gi Learning Center</h1>
					<p>The Gi health Learning Center is a free public resource.</p>
				</div>
			</div>,
            <div className="main-wrapper row" key={'main-wrapper'}>
                <BodyOverlay activeBodyParts={activeBodyParts} />
                <div className="large-7 small-12 column end">
					<div className="main">
                        {this.props.thanksRegisteringMessage &&
                            <Callout type="success" message={this.props.thanksRegisteringMessage} handleClose={this.handleStateMessageCalloutClose} />
                        }
                        <h2>Welcome to the Gi Learning Center</h2>
                        <p>Learn about GI symptoms, diseases, what causes them, and understand how to manage them with behavioral changes and medications.</p>
                        <MainNav
                           bodyParts={bodyparts}
                           symptoms={symptoms}
                           diseases={this.props.diseases}
                           qols={qols}
                           toggleBodyParts={this.handleToggleBodyParts}
                           toggleEducation={this.handleToggleEducation}
                           activeEducationToggle={activeEducationToggle}
                           clickTracking={this.props.recordEducationClick}
                           clickTrackingOfAGA={this.props.recordAGAEducationClick}
                        />
					</div>
                </div>
            </div>,
			<div className="app-promo-wrapper" key={'app-promo-wrapper'}>
				<div className="row column">
					<AppPromo
						pageTitle={this.pageTitle}
						recordDownloadClick={this.props.recordDownloadClick} />
				</div>
			</div>
        ];

        var content = (
            <Loader loaded={this.hasDataLoaded()}>
                {children}
            </Loader>
        );

        if(this.hasDataLoaded()){
            content = children;
        }

        return content;
    },

    render: function(){
        return (
            <div className="content">
        <Helmet
            title={this.pageTitle}
            meta={[{
                name: 'description',
                content: 'Learn about gastrointestinal tract problems, make educated decisions, and get relief from GI issues.'
            }]}/>

    {this.getContent()}

                <div className="reveal" id="newsletter-success">
                    <button className="close-button" data-close="" aria-label="Close reveal" type="button" onClick={this.handleModal}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h1>Thanks for joining our newsletter!</h1>
                    <h4>You&#39;ll be one of the first to know about new features and updates.</h4>
                    <h3>In the meantime, please feel free to close this message and explore our new Gi Learning Center!</h3>
                    <div className="close" data-close="" onClick={this.handleModal}>
                        <h5><i className="ion-ios-close-empty" />Close this message</h5>
                    </div>
                </div>
				<div id="preload">
					<img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/icon-symptoms-active.png" alt="" />
					<img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/icon-diseases-active.png" alt="" />
					<img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/icon-bodyparts-active.png" alt="" />
					<img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/icon-qols-active.png" alt="" />
				</div>
            </div>
        )
    }
});

module.exports = Education



// WEBPACK FOOTER //
// ./src/common/routes/education/components/education.jsx